import Contents from '../Layouts/Contents'
import Credit from '../Layouts/Credits'
import styles from './index.module.scss'

const QuickStart = () => {
  return (
    <div>
        <div className={styles.layout}>
            <Contents />
            <div className={styles.start}>
                <div>
                    <h1>Welcome to Dreamvast Doc!</h1>
                    <p>Here you will find documentation about Dreamvast commands, configuration, permissions and more.</p>
                    <p>You can easily plug Dreamvast into your Discord server and get started.</p>
                </div>
                <div style={{ padding: '20px 0px' }}>
                    <h1>Setting up the bot</h1>
                    <p>
                        Dreamvast is made to be simple to use! 
                        Getting Dreamvast running on your server is easy. 
                        You can invite Dreamvast by authenticating it with your account using <a href={'/invite'} target="_blank" rel="noreferrer">
                        <strong>
                            this link. 
                            </strong>
                        </a> You must have <strong>Manage Server</strong> permissions to be able to do this.
                    </p>
                </div>
                <div>

                    <div>
                        <h1>Adding music to the playlist</h1>
                        <p>
                            It is easy to add your favorite music to the playlist. 
                            To start playing a track, use the d!play command.
                        </p>
                    </div>

                    <div className={styles.examples}>
                        <div style={{ padding: '0px 0px 10px' }}>
                            <p>Examples:</p>
                        </div>
                        <div className={styles.markdown}>
                            <p>/play https://www.youtube.com/watch?v=uX0QXQZdbuo</p>
                            <p>/play mikudayo</p>
                        </div>
                    </div>

                    <div className={styles.examples}>
                        <div style={{ padding: '0px 0px 10px' }}>
                            <p>
                                You can either explicitly state the URL, or you can get Dreamvast to search YouTube and give you some choices by using search command. 
                                Here′s an example:
                            </p>
                        </div>
                        <div className={styles.markdown}>
                            <p>/search mikudayo</p>
                        </div>
                        <div style={{ padding: '10px 0px 10px' }}>
                            <p>When you use that command, it will show a respond or something like this:</p>
                        </div>
                        <div className={styles.markdown}>
                            <p>Song Selection...</p>
                            <p>1: 【CM】 Thank Heaven, Seven Eleven 【Fiction】 01:14 Author: DSpec28</p>
                            <p>2: Mikudayo 01:45 Author: man what </p>
                            <p>3: Together With Mikudayo But Every Time Mikudayo Suffers It Gets Depressing (3/3) 06:35 Author: Susumu</p>
                            <p>4: Mikudayo sushi 01:06 Author: Jiggy -Jelly-</p>
                            <p>5: Mikudayo 00:16 Author: Rimi</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Credit />
    </div>
  )
}

export default QuickStart